let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lE5Un")).then(() => parcelRequire('dSNBY'));